export var SpriteSheetBannerElementName;
(function (SpriteSheetBannerElementName) {
    SpriteSheetBannerElementName["Background"] = "background";
    SpriteSheetBannerElementName["BackgroundZIndex1"] = "background-zIndex-1";
    SpriteSheetBannerElementName["BoxStakeAmount"] = "box-stake-amount";
    SpriteSheetBannerElementName["CircleBlack"] = "circle-black";
    SpriteSheetBannerElementName["CircleWhite"] = "circle-white";
    SpriteSheetBannerElementName["CircleTransparent"] = "circle-transparent";
    SpriteSheetBannerElementName["CircleLight"] = "circle-light";
    SpriteSheetBannerElementName["CircleLightZIndex1"] = "circle-light-zIndex-1";
    SpriteSheetBannerElementName["CircleLightZIndex2"] = "circle-light-zIndex-2";
    SpriteSheetBannerElementName["CircleLightZIndex3"] = "circle-light-zIndex-3";
    SpriteSheetBannerElementName["IconBall1"] = "icon-ball-1";
    SpriteSheetBannerElementName["IconBall1Step1"] = "icon-ball-1-step-1";
    SpriteSheetBannerElementName["IconBall1Step2"] = "icon-ball-1-step-2";
    SpriteSheetBannerElementName["IconBall2"] = "icon-ball-2";
    SpriteSheetBannerElementName["IconBall2Step1"] = "icon-ball-2-step-1";
    SpriteSheetBannerElementName["IconBall2Step2"] = "icon-ball-2-step-2";
    SpriteSheetBannerElementName["IconBall3"] = "icon-ball-3";
    SpriteSheetBannerElementName["IconBall3Step1"] = "icon-ball-3-step-1";
    SpriteSheetBannerElementName["IconBall3Step2"] = "icon-ball-3-step-2";
    SpriteSheetBannerElementName["IconBall4"] = "icon-ball-4";
    SpriteSheetBannerElementName["IconBall4Step1"] = "icon-ball-4-step-1";
    SpriteSheetBannerElementName["IconBall4Step2"] = "icon-ball-4-step-2";
    SpriteSheetBannerElementName["IconBall5Step1"] = "icon-ball-5-step-1";
    SpriteSheetBannerElementName["IconBall5Step2"] = "icon-ball-5-step-2";
    SpriteSheetBannerElementName["IconCoinsWon"] = "icon-coins-won";
    SpriteSheetBannerElementName["IconUserAway"] = "icon-user-away";
    SpriteSheetBannerElementName["IconUserHome"] = "icon-user-home";
    SpriteSheetBannerElementName["InviteStar"] = "invite-star";
    SpriteSheetBannerElementName["BgWinning"] = "bg-winning";
    SpriteSheetBannerElementName["IconClover"] = "icon-clover";
    SpriteSheetBannerElementName["IconCoinRotate"] = "icon-coin-rotate";
    SpriteSheetBannerElementName["IconDiamondBlue"] = "icon-diamond-blue";
    SpriteSheetBannerElementName["IconDiamondSilver"] = "icon-diamond-silver";
    SpriteSheetBannerElementName["IconGift"] = "icon-gift";
    SpriteSheetBannerElementName["IconMedal"] = "icon-medal";
})(SpriteSheetBannerElementName || (SpriteSheetBannerElementName = {}));
export var SpriteSheetLeaderboardElementName;
(function (SpriteSheetLeaderboardElementName) {
    SpriteSheetLeaderboardElementName["CloseBtn"] = "close-btn";
    SpriteSheetLeaderboardElementName["LeaderboardTop1"] = "leader-board-top1";
    SpriteSheetLeaderboardElementName["LeaderboardTop2"] = "leader-board-top2";
    SpriteSheetLeaderboardElementName["LeaderboardTop3"] = "leader-board-top3";
    SpriteSheetLeaderboardElementName["LeaderboardTop4"] = "leader-board-top4";
    SpriteSheetLeaderboardElementName["LeaderboardTop5"] = "leader-board-top5";
    SpriteSheetLeaderboardElementName["LeaderboardTop6"] = "leader-board-top6";
    SpriteSheetLeaderboardElementName["LeaderboardTop7"] = "leader-board-top7";
    SpriteSheetLeaderboardElementName["LeaderboardTop8"] = "leader-board-top8";
    SpriteSheetLeaderboardElementName["LeaderboardTop9"] = "leader-board-top9";
    SpriteSheetLeaderboardElementName["LeaderboardTop10"] = "leader-board-top10";
    SpriteSheetLeaderboardElementName["BoxNotFound"] = "box-not-found";
    SpriteSheetLeaderboardElementName["IconNotFound"] = "icon-not-found";
})(SpriteSheetLeaderboardElementName || (SpriteSheetLeaderboardElementName = {}));
export var SessionDetailFileName;
(function (SessionDetailFileName) {
    SessionDetailFileName["BannerDisable"] = "banner-disable";
    SessionDetailFileName["ArrowRight"] = "arrow-right";
    SessionDetailFileName["ArrowLeft"] = "arrow-left";
    SessionDetailFileName["BannerHome1"] = "banner-home-1";
    SessionDetailFileName["BannerAway1"] = "banner-away-1";
    SessionDetailFileName["ArrowDown"] = "arrow-down";
    SessionDetailFileName["PlayerIcon"] = "player-icon";
    SessionDetailFileName["SessionTitle"] = "session-tittle";
    SessionDetailFileName["BtnClose"] = "btn-close";
    SessionDetailFileName["Undo"] = "undo";
})(SessionDetailFileName || (SessionDetailFileName = {}));
